import AccessTokenStore from '../../lib/accessTokenStore'
import isInIframe from '../../utils/isInIframe'


// A guest identity answers a refusal only for a visitor who has no identity at
// all, on a page that has a use for one, on a page that is not framed.
//
// Every guest is a permanent identity on the server, so none is created for a
// visit that has no use for one, such as accepting an invitation.
//
// A held token says the visitor already has an identity, and the refusal is
// for that token rather than for having none.
//
// Inside a frame on another site our cookies are third-party, so the guest the
// call creates would be one that nobody can use.
//
export default function shouldBootstrapGuestOnRefusal({ isGuestWelcome, isUnauthorized }) {
  if ( !isGuestWelcome || !isUnauthorized ) {
    return false
  }

  if ( isInIframe() ) {
    return false
  }

  return !AccessTokenStore.getAccessToken()
}
